/**
 * Accordion Module
 * Handles accordion functionality for the custom accordion block
 * Extends BaseAccordion for consistent behavior
 */

import { onDOMReady, devLog } from './utils.js';
import { BaseAccordion } from './base-accordion.js';

class Accordion extends BaseAccordion {
    constructor() {
        super({
            selector: '[data-accordion-toggle]',
            debug: false
        });
    }

    // Override the CSS classes to use accordion specific classes
    openAccordion(toggle, content) {
        super.openAccordion(toggle, content);
        
        // Add accordion specific classes
        toggle.classList.add('accordion__toggle--expanded');
        content.classList.add('accordion__content--expanded');
    }

    closeAccordion(toggle, content) {
        super.closeAccordion(toggle, content);
        
        // Remove accordion specific classes
        toggle.classList.remove('accordion__toggle--expanded');
        content.classList.remove('accordion__content--expanded');
    }
}

// Initialize when DOM is loaded
onDOMReady(() => {
    new Accordion();
});

// Re-initialize for dynamic content (like in block editor)
if (typeof acf !== 'undefined') {
    acf.add_action('append', function($el) {
        new Accordion();
    });
} 